export default {
  BUGSNAG_API_KEY: String(import.meta.env.VITE_BUGSNAG_API_KEY) || null,
}
